import React, { useEffect, useState } from "react";
import api, { formatTL, formatDate } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Link } from "react-router-dom";

const STATUS_META = {
  completed: { label: "Tamamlandı", class: "bg-emerald-100 text-emerald-800 border-emerald-200" },
  cancelled: { label: "İptal", class: "bg-red-100 text-red-800 border-red-200" },
  refunded: { label: "İade", class: "bg-amber-100 text-amber-800 border-amber-200" },
  partial_refunded: { label: "Kısmi İade", class: "bg-amber-100 text-amber-800 border-amber-200" },
};

const PAY_LABEL = { nakit: "Nakit", havale: "Havale", karma: "Karma" };

export default function Sales() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const { isAdmin } = useAuth();

  useEffect(() => {
    api
      .get("/sales")
      .then((r) => setItems(r.data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="sales-root">
      <div className="mb-6">
        <div className="font-mono-code text-[10px] tracking-[0.3em] text-stone-500">
          KAYITLAR
        </div>
        <h1 className="font-serif-display text-3xl sm:text-4xl text-stone-900">
          {isAdmin ? "Satışlar" : "Satışlarım"}
        </h1>
      </div>

      <div className="card-lux overflow-hidden">
        <div className="overflow-x-auto">
          <table className="min-w-full">
            <thead className="bg-stone-50 border-b border-stone-200">
              <tr className="text-xs uppercase tracking-wider text-stone-500">
                <th className="px-3 py-3 text-left">Satış No</th>
                <th className="px-3 py-3 text-left">Tarih</th>
                {isAdmin && <th className="px-3 py-3 text-left">Kasiyer</th>}
                <th className="px-3 py-3 text-right">Adet</th>
                <th className="px-3 py-3 text-right">Ara Toplam</th>
                <th className="px-3 py-3 text-right">İndirim</th>
                <th className="px-3 py-3 text-right">Net Toplam</th>
                <th className="px-3 py-3 text-right">Nakit</th>
                <th className="px-3 py-3 text-right">Havale</th>
                <th className="px-3 py-3 text-left">Ödeme</th>
                <th className="px-3 py-3 text-left">Durum</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-stone-100">
              {loading && (
                <tr>
                  <td colSpan={11} className="text-center py-10 text-stone-400">
                    Yükleniyor…
                  </td>
                </tr>
              )}
              {!loading && items.length === 0 && (
                <tr>
                  <td colSpan={11} className="text-center py-14 text-stone-500">
                    Henüz satış kaydı yok.
                  </td>
                </tr>
              )}
              {items.map((s) => {
                const st = STATUS_META[s.status] || STATUS_META.completed;
                return (
                  <tr
                    key={s.id}
                    data-testid={`sale-row-${s.sale_number}`}
                    className="hover:bg-amber-50/30 cursor-pointer"
                    onClick={() => (window.location.href = `/satislar/${s.id}`)}
                  >
                    <td className="px-3 py-3 text-sm font-mono-code text-amber-800 font-semibold">
                      {s.sale_number}
                    </td>
                    <td className="px-3 py-3 text-xs text-stone-600 font-mono-code">
                      {formatDate(s.created_at)}
                    </td>
                    {isAdmin && (
                      <td className="px-3 py-3 text-sm text-stone-800">
                        {s.cashier_name}
                      </td>
                    )}
                    <td className="px-3 py-3 text-right font-mono-code text-sm">
                      {s.item_count}
                    </td>
                    <td className="px-3 py-3 text-right font-mono-code text-sm text-stone-600">
                      {formatTL(s.subtotal)}
                    </td>
                    <td className="px-3 py-3 text-right font-mono-code text-sm text-red-700">
                      -{formatTL(s.discount_total)}
                    </td>
                    <td className="px-3 py-3 text-right font-mono-code text-sm font-semibold text-amber-800">
                      {formatTL(s.total)}
                    </td>
                    <td className="px-3 py-3 text-right font-mono-code text-sm text-stone-700">
                      {formatTL(s.cash_amount)}
                    </td>
                    <td className="px-3 py-3 text-right font-mono-code text-sm text-stone-700">
                      {formatTL(s.transfer_amount)}
                    </td>
                    <td className="px-3 py-3 text-sm text-stone-700">
                      {PAY_LABEL[s.payment_method] || s.payment_method}
                    </td>
                    <td className="px-3 py-3">
                      <span
                        className={`inline-flex text-[11px] px-2 py-0.5 rounded-full border font-medium ${st.class}`}
                      >
                        {st.label}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
